import React, { useEffect } from "react";
import styles from "./InputBox.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Input, Tooltip } from "antd";
const containerStyles = {
  borderColor: '#E0E2E6',
  boxShadow: '0px 1px 2px 0px #1018280D',
  color: '#5C667B !important',
  zIndex: '0',
  width: "100%"
}

export default function InputBox({ name, JobId, handleChangeText, link, Url }) {
  const state = useSelector((state) => state.atomizer);
  const renderInputValue = () => {
    switch (state.sourceType) {
      case "PDF":
      case "Image":
      case "Video":
      case "Multiple Files":
      case "List of PDF URL links (CSV)":
        return JobId;
      case "Scrap Url":
        return name;
      // case "Pdf URL Link":
      //   return Url;

      default:
        break;
    }
  };

  return (
    <>
      {/* <input
        sx={{ border: 1 }}
        // className={styles.textInput}
        onChange={handleChangeText}
        width="100%"
        value={renderInputValue()}
        style={containerStyles}
        disabled={state?.loading ? true : false}
      /> */}
      <Input
        // placeholder="Write additional details..."
        style={containerStyles}
        value={renderInputValue()}
        disabled={state?.loading ? true : false}
        onChange={handleChangeText}
      />
    </>
  );
}
